export function capitalize(word = '') {
  const lower = (word || '').toLowerCase();
  return lower
    .split(' ')
    .map((part) =>
      part.length > 1 ? part.charAt(0).toUpperCase() + part.slice(1) : part,
    )
    .join(' ');
}
